"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _bonusSend = require("@/api/activity/bonusSend");
var _index = require("@/utils/index");
var _ActivityQrcodeDialog = _interopRequireDefault(require("@/components/ActivityQrcodeDialog"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BonusSendTablePane',
  components: {
    ActivityQrcodeDialog: _ActivityQrcodeDialog.default
  },
  data: function data() {
    return {
      searchForm: {
        keyword: ''
      },
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      events: {
        1: '注册',
        2: '一键领取',
        3: '领券中心',
        4: '私域领券',
        5: '问卷方法',
        6: '下单',
        7: '会员日'
      },
      qrDialogVisible: false,
      qrItems: [],
      qrTitle: ''
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, records, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.tableLoading = true;
              _context.prev = 1;
              params = {
                page: this.currentPage,
                limit: this.pageSize,
                keyword: this.searchForm.keyword
              };
              _context.next = 2;
              return (0, _bonusSend.getBonusSendList)(params);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                records = response.records || []; // 处理优惠券展示
                this.tableData = records.map(function (item) {
                  var bonusDisplay = '-';
                  if (item.bonus) {
                    try {
                      // 解析 bonus JSON
                      var bonusData = typeof item.bonus === 'string' ? JSON.parse(item.bonus) : item.bonus;
                      if (bonusData && bonusData.detail && Array.isArray(bonusData.detail)) {
                        // 生成展示内容：couponTitle（sendNum），一行一个
                        var displayList = bonusData.detail.map(function (detail) {
                          var title = detail.couponTitle || detail.couponAlias || '未知券';
                          var num = detail.sendNum || 1;
                          return "<div>".concat(title, "\uFF08").concat(num, "\uFF09</div>");
                        });
                        bonusDisplay = displayList.join('');
                      }
                    } catch (e) {
                      console.error('解析bonus失败:', e);
                      bonusDisplay = '-';
                    }
                  }
                  return _objectSpread(_objectSpread({}, item), {}, {
                    bonusDisplay: bonusDisplay
                  });
                });
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取数据失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.$message.error('获取数据失败：' + _t.message);
            case 4:
              _context.prev = 4;
              this.tableLoading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        keyword: ''
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleAdd: function handleAdd() {
      this.$emit('toBonusSendConfig', null, 1);
    },
    handleEdit: function handleEdit(row) {
      this.$emit('toBonusSendConfig', row.id, row.sendType);
    },
    handleShowRecord: function handleShowRecord(row) {
      this.$emit('toBonusSendRecord', row);
    },
    handleCopy: function () {
      var _handleCopy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!row || !row.id)) {
                _context3.next = 1;
                break;
              }
              this.$message.warning('无法复制：数据异常');
              return _context3.abrupt("return");
            case 1:
              this.$confirm('确定要一键复制此发放活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, _t2;
                return regeneratorRuntime.wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 1;
                      return (0, _bonusSend.copyBonusSend)(row.id);
                    case 1:
                      response = _context2.sent;
                      if (response.code === 200) {
                        _this.$message.success('复制成功');
                        _this.fetchData();
                      } else {
                        _this.$message.error(response.message || '复制失败');
                      }
                      _context2.next = 3;
                      break;
                    case 2:
                      _context2.prev = 2;
                      _t2 = _context2["catch"](0);
                      _this.$message.error('复制失败：' + _t2.message);
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 2]]);
              }))).catch(function () {});
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleCopy(_x) {
        return _handleCopy.apply(this, arguments);
      }
      return handleCopy;
    }(),
    handleQrcode: function handleQrcode(row) {
      if (!row || !row.id) {
        this.$message.warning('无法生成二维码：数据异常');
        return;
      }
      if (row.event === 7) {
        // 会员日仅社区端
        this.qrItems = [{
          label: '社区端',
          url: "".concat(process.env.VUE_APP_COMMUNITY_URL, "/bonusSend/memberDayBonus/").concat(row.id)
        }];
      } else {
        // 一键领取 / 领券中心 对应不同的链接，均仅点餐端
        var path = row.event === 2 ? 'oneClick' : 'couponCenter';
        this.qrItems = [{
          label: '点餐端',
          url: "".concat(process.env.VUE_APP_ACTIVITY_URL, "/bonusSend/").concat(path, "/").concat(row.id)
        }];
      }
      this.qrTitle = row.title || this.getEventName(row.event);
      this.qrDialogVisible = true;
    },
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm('确认删除该发放活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var response, _t3;
                return regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      _context4.next = 1;
                      return (0, _bonusSend.deleteBonusSend)(row.id);
                    case 1:
                      response = _context4.sent;
                      if (response.code === 200) {
                        _this2.$message.success('删除成功');
                        _this2.fetchData();
                      } else {
                        _this2.$message.error(response.message || '删除失败');
                      }
                      _context4.next = 3;
                      break;
                    case 2:
                      _context4.prev = 2;
                      _t3 = _context4["catch"](0);
                      _this2.$message.error('删除失败：' + _t3.message);
                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[0, 2]]);
              }))).catch(function () {});
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    handleStatusChange: function () {
      var _handleStatusChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return (0, _bonusSend.toggleBonusSendStatus)(row.id, row.enabled);
            case 1:
              response = _context6.sent;
              if (response.code === 200) {
                this.$message.success('状态更新成功');
                this.fetchData();
              } else {
                row.enabled = row.enabled === 1 ? 0 : 1;
                this.$message.error(response.message || '状态更新失败');
              }
              _context6.next = 3;
              break;
            case 2:
              _context6.prev = 2;
              _t4 = _context6["catch"](0);
              row.enabled = row.enabled === 1 ? 0 : 1;
              this.$message.error('状态更新失败：' + _t4.message);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function handleStatusChange(_x3) {
        return _handleStatusChange.apply(this, arguments);
      }
      return handleStatusChange;
    }(),
    getEventName: function getEventName(event) {
      return this.events[event] || '-';
    },
    getEventType: function getEventType(event) {
      // 为不同事件类型返回不同的标签颜色
      var typeMap = {
        1: 'success',
        // 注册 - 绿色
        2: 'primary',
        // 一键领取 - 蓝色
        3: 'danger',
        // 领券中心 - 红色
        4: 'info',
        // 私域领券 - 灰色
        5: 'warning',
        // 问卷方法 - 橙色
        6: '',
        // 下单 - 默认
        7: 'warning' // 会员日 - 橙色
      };
      return typeMap[event] || '';
    },
    formatTime: function formatTime(time) {
      if (!time) return '-';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}');
    }
  }
};